(() => {
  'use strict';
  const NS = 'http://www.w3.org/2000/svg';
  // Calibrated against the eight 1254px solid-colour product photographs.
  // Each triple is the top-left, top-right and bottom-left of the printable area.
  const areas = {
    red: [[790,589],[1120,550],[801,670]],
    black: [[770,579],[1071,544],[781,651]],
    beige: [[799,589],[1100,548],[811,665]],
    green: [[783,589],[1070,553],[793,661]],
    'sky-blue': [[791,588],[1076,555],[801,662]],
    'mei-red': [[764,599],[1039,573],[772,664]],
    grey: [[800,589],[1100,550],[811,662]],
    orange: [[790,589],[1099,550],[801,665]]
  };
  const colourOf = image => (image.getAttribute('src') || '').match(/luvly-harness-solid-(sky-blue|mei-red|red|black|beige|green|grey|orange)(?=[._])/)?.[1];
  function lettering(colour) {
    const [a,b,c] = areas[colour];
    const svg = document.createElementNS(NS,'svg');
    svg.setAttribute('viewBox','0 0 1254 1254');
    svg.setAttribute('aria-hidden','true');
    svg.setAttribute('focusable','false');
    svg.dataset.patchLettering = '';
    svg.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;visibility:hidden;';
    const group = document.createElementNS(NS,'g');
    group.setAttribute('transform',`matrix(${(b[0]-a[0])/320} ${(b[1]-a[1])/320} ${(c[0]-a[0])/90} ${(c[1]-a[1])/90} ${a[0]} ${a[1]})`);
    const text = document.createElementNS(NS,'text');
    text.setAttribute('x','160');
    text.setAttribute('y','45');
    text.setAttribute('text-anchor','middle');
    text.setAttribute('dominant-baseline','central');
    text.setAttribute('fill','#fffaf0');
    text.setAttribute('font-family','Arial, Helvetica, sans-serif');
    text.setAttribute('font-weight','700');
    text.setAttribute('letter-spacing','0.6');
    group.append(text); svg.append(group);
    return {svg,text};
  }
  function init(section) {
    if (section.dataset.patchPreviewReady) return;
    const patch = section.querySelector('[data-patch]');
    const toggle = patch?.querySelector('[data-patch-toggle]');
    const field = patch?.querySelector('[data-patch-text]');
    const fields = patch?.querySelector('[data-patch-fields]');
    if (!toggle || !field || !fields) return;
    const originals = Array.from(section.querySelectorAll('[data-product-slider] .product__slide img'))
      .map(image => ({image,colour:colourOf(image)})).filter(item => item.colour);
    if (!originals.length) return;
    section.dataset.patchPreviewReady = 'true';
    const layers = originals.map(item => {
      const layer = lettering(item.colour);
      item.image.parentElement.style.position = 'relative';
      item.image.parentElement.append(layer.svg);
      return {...item,...layer};
    });
    const figure = document.createElement('figure');
    figure.dataset.patchLivePreview = '';
    figure.style.cssText = 'margin:14px auto 0;max-width:280px;';
    const frame = document.createElement('div');
    frame.style.cssText = 'position:relative;aspect-ratio:1;overflow:hidden;border-radius:16px;background:#fff8ec;';
    const previewImage = document.createElement('img');
    previewImage.style.cssText = 'display:block;width:100%;height:100%;object-fit:contain;';
    previewImage.alt = 'Your personalised harness preview';
    const caption = document.createElement('figcaption');
    caption.textContent = 'Your patch preview';
    caption.style.cssText = 'text-align:center;font-size:12px;margin-top:6px;opacity:.75;';
    frame.append(previewImage); figure.append(frame,caption); fields.append(figure);
    const sample = patch.querySelector('.harness-patch__preview');
    const sampleDisplay = sample?.style.display || '';
    let mini = null;
    const selectedImage = () => {
      const selected = section.querySelector('[data-variant-picker] fieldset input:checked');
      const colour = selected?.value.toLowerCase().replaceAll(' ','-');
      return originals.find(item => item.colour === colour) || originals[0];
    };
    const fitText = (layer,value) => {
      layer.text.textContent = value;
      layer.text.setAttribute('font-size','56');
      const width = layer.text.getComputedTextLength();
      if (width > 286) layer.text.setAttribute('font-size',String(56 * 286 / width));
      layer.svg.style.visibility = toggle.checked && value ? 'visible' : 'hidden';
    };
    const update = () => {
      const value = field.value.trim().replace(/\s+/g,' ');
      const item = selectedImage();
      previewImage.src = item.image.currentSrc || item.image.src;
      if (mini?.colour !== item.colour) {
        mini?.svg.remove();
        mini = {...lettering(item.colour),colour:item.colour};
        frame.append(mini.svg);
      }
      [...layers,mini].forEach(layer => fitText(layer,value));
      figure.hidden = !toggle.checked;
      // The live harness replaces the static sample beside the name field.
      if (sample) {
        sample.hidden = toggle.checked;
        sample.style.display = toggle.checked ? 'none' : sampleDisplay;
      }
    };
    field.addEventListener('input',update);
    section.addEventListener('change',update);
    update();
  }
  const initAll = root => root.querySelectorAll('[data-product-section]').forEach(init);
  initAll(document);
  document.addEventListener('shopify:section:load',event => initAll(event.target.parentElement || document));
})();
